import React, { useMemo } from 'react';
import type { WaterfallTimings } from '@/types/trace';

interface WaterfallTimelineProps {
  timings: WaterfallTimings;
  zoom: number;
}

export function WaterfallTimeline({ timings, zoom }: WaterfallTimelineProps) {
  const baseWidth = 400;
  const timelineWidth = baseWidth * zoom;

  const markers = useMemo(() => {
    const duration = timings.totalDuration;
    const numMarkers = Math.max(2, Math.min(10, Math.ceil(duration / 1000)));
    const interval = duration / (numMarkers - 1);

    return Array.from({ length: numMarkers }, (_, i) => ({
      position: (i / (numMarkers - 1)) * 100,
      time: i * interval,
    }));
  }, [timings]);

  const formatTime = (ms: number) => {
    if (ms < 1000) return `${Math.round(ms)}ms`;
    return `${(ms / 1000).toFixed(1)}s`;
  };

  return (
    <div className="flex items-center border-b bg-muted/30">
      {/* Label Column */}
      <div className="w-48 flex-shrink-0 px-2 py-1 text-xs font-medium text-muted-foreground border-r">
        Component
      </div>

      {/* Timeline Column */}
      <div className="relative h-6 flex-1" style={{ minWidth: timelineWidth }}>
        {markers.map((marker, i) => (
          <div
            key={i}
            className="absolute top-0 bottom-0 flex flex-col items-center"
            style={{ left: `${marker.position}%` }}
          >
            <div className="h-full w-px bg-border" />
            <span className="absolute bottom-0 text-[10px] text-muted-foreground whitespace-nowrap transform -translate-x-1/2">
              {formatTime(marker.time)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default WaterfallTimeline;
